const confirmLeave = {
  data () {
    return {
      next: null
    }
  },
  beforeRouteLeave(to, from , next) {
    if (!this.$auth.access_token)
      next();
    if (this.dirty)
      this.next = next;
    else
      next();
  }
}

export default confirmLeave;